module.exports = __webpack_public_path__ + "static/media/tilt.a12618fc.jpg";